import { render, staticRenderFns } from "./user_positions.vue?vue&type=template&id=f9b9431a&"
import script from "./user_positions.vue?vue&type=script&lang=js&"
export * from "./user_positions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports